import CookiePolicyTemplate from '@/components/template/CookiePolicyTemplate';
import Head from 'next/head';

const Legal = () => {
  return (
    <>
      <Head>
        <title key="title">
          Cookie Policy - {process.env.NEXT_PUBLIC_DOMAIN ?? 'EV.com'}
        </title>
        <meta
          name="description"
          content={`Cookie Policy - ${
            process.env.NEXT_PUBLIC_DOMAIN ?? 'EV.com'
          }`}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <main className="bg-blue-light pt-[14px]">
        <CookiePolicyTemplate />
      </main>
    </>
  );
};

export default Legal;
